import { useMemo } from 'react';

import { useGetMarineLovs } from '../proposal.slice';

export function useMarineLovs(isMarine: boolean) {
  const { data } = useGetMarineLovs({ skip: !isMarine });

  return useMemo(() => {
    const currencies = data?.core?.getCurrencies ?? [];
    const matters = data?.production?.getMatters ?? [];

    const mattersRec: Record<string, string> = {};
    matters.forEach((m: any) => (mattersRec[m.id] = m.title ?? m.code ?? ''));

    const currenciesRec: Record<string, string> = {};
    const currencySymbols: Record<string, string> = {};
    currencies.forEach((c: any) => {
      currenciesRec[c.id] = c.title ?? c.code ?? '';
      currencySymbols[c.id] = (c as any).symbol ?? '';
    });

    return { matters: mattersRec, currencies: currenciesRec, currencySymbols };
  }, [data]);
}
